import React, { useState } from "react";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import Topbarmenu from "./Topbarmenu";

function Topbar() {
  let navUserLogOut = useNavigate();
  const [logout, setLogOut] = useState(false);

  const callJQueryFunction = () => {
    // Call your jQuery function
    $("#sidebarToggle, #sidebarToggleTop").on("click", function (e) {
      $("body").toggleClass("sidebar-toggled");
      $(".sidebar").toggleClass("toggled");
      if ($(".sidebar").hasClass("toggled")) {
        //$(".sidebar .collapse").collapse(); //.collapse('hide');
      }
    });
  };
  const handleLogout = () => {
    //sessionStorage.removeItem("user_credential");
    sessionStorage.clear();
    window.location.href = "/";
  };
  let navNaigate = useNavigate();

  const handlenavigate = (path) => {
    navNaigate(path);
  };

  const handleTopBarMenuClick = (path) => {
    //sessionStorage.removeItem("add_tmpl_fld");
    //sessionStorage.removeItem("rec_id");
    const user_cred = sessionStorage.getItem("user_credential");
    sessionStorage.clear();
    if (user_cred !== null) {
      sessionStorage.setItem("user_credential", user_cred);
    }

    navNaigate(path);
  };

  return (
    <div>
      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
        <button
          id="sidebarToggleTop"
          className="btn btn-link d-md-none rounded-circle mr-3"
          title="Toggle"
          onClick={() => callJQueryFunction()}
        >
          <i className="fa fa-bars"></i>
        </button>
        {/*<Topbarmenu />*/}
        <h5>
          {sessionStorage.getItem("sel_tmpl")
            ? JSON.parse(sessionStorage.getItem("sel_tmpl")).tmpl_name
            : ""}
        </h5>

        <ul className="navbar-nav ml-auto mr">
          {/* Nav Item - Search Dropdown (Visible Only XS)*/}
          <li
            className="mr-2 d-none d-lg-inline text-gray-600 small mt-3 active"
            title="Home"
          >
            <a
              className="nav-link"
              style={{ cursor: "pointer" }}
              onClick={() => handleTopBarMenuClick("/")}
            >
              <i className="icon fas fa-home"></i>&nbsp;Home
            </a>
          </li>
          <li className="mr-2 d-none d-lg-inline text-gray-600 small mt-3">
            <a
              className="nav-link"
              onClick={() => handleTopBarMenuClick("/surveysearch")}
              style={{ cursor: "pointer" }}
            >
              <i className="icon fas fa-file"></i>&nbsp;My Survey
            </a>
          </li>
          {/*<li className="mr-2 d-none d-lg-inline text-gray-600 small mt-3">
            <a
              className="nav-link"
              onClick={() => handleTopBarMenuClick("/surveyadd")}
              style={{ cursor: "pointer" }}
            >
              <i className="icon fas fa-plus"></i>&nbsp; New Survey
            </a>
          </li>*/}
          <li className="mr-2 d-none d-lg-inline text-gray-600 small mt-3">
            <a className="nav-link" href="#" style={{ cursor: "pointer" }}>
              <i className="icon fas fa-question"></i>&nbsp;Help
            </a>
          </li>
          {/* Nav Item - Alerts */}
          <li className="nav-item dropdown no-arrow mx-1">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="alertsDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-bell fa-fw"></i>
              {/*Counter - Alerts */}
              <span className="badge badge-danger badge-counter">3+</span>
            </a>
            {/* Dropdown - Alerts */}
            <div
              className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="alertsDropdown"
            >
              <h6 className="dropdown-header">Alerts Center</h6>
              <a className="dropdown-item d-flex align-items-center" href="#">
                <div className="mr-3">
                  <div className="icon-circle bg-primary">
                    <i className="fas fa-file-alt text-white"></i>
                  </div>
                </div>
                <div>
                  <div className="small text-gray-500">December 12, 2019</div>
                  <span className="font-weight-bold">
                    A new monthly report is ready to download!
                  </span>
                </div>
              </a>
              <a className="dropdown-item d-flex align-items-center" href="#">
                <div className="mr-3">
                  <div className="icon-circle bg-success">
                    <i className="fas fa-donate text-white"></i>
                  </div>
                </div>
                <div>
                  <div className="small text-gray-500">December 7, 2019</div>
                  $290.29 has been deposited into your account!
                </div>
              </a>
              <a className="dropdown-item d-flex align-items-center" href="#">
                <div className="mr-3">
                  <div className="icon-circle bg-warning">
                    <i className="fas fa-exclamation-triangle text-white"></i>
                  </div>
                </div>
                <div>
                  <div className="small text-gray-500">December 2, 2019</div>
                  Spending Alert: We've noticed unusually high spending for your
                  account.
                </div>
              </a>
              <a
                className="dropdown-item text-center small text-gray-500"
                href="#"
              >
                Show All Alerts
              </a>
            </div>
          </li>

          {/*Nav Item - Messages */}
          <li className="nav-item dropdown no-arrow mx-1">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="messagesDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-envelope fa-fw"></i>
              {/* Counter - Messages */}
              <span className="badge badge-danger badge-counter">7</span>
            </a>
            {/* Dropdown - Messages */}
            <div
              className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="messagesDropdown"
            >
              <h6 className="dropdown-header">Message Center</h6>
              <a className="dropdown-item d-flex align-items-center" href="#">
                <div className="dropdown-list-image mr-3">
                  <img
                    className="rounded-circle"
                    src="img/undraw_profile_1.svg"
                    alt="..."
                  />
                  <div className="status-indicator bg-success"></div>
                </div>
                <div className="font-weight-bold">
                  <div className="text-truncate">
                    Hi there! I am wondering if you can help me with a problem
                    I've been having.
                  </div>
                  <div className="small text-gray-500">Emily Fowler · 58m</div>
                </div>
              </a>
              <a className="dropdown-item d-flex align-items-center" href="#">
                <div className="dropdown-list-image mr-3">
                  <img
                    className="rounded-circle"
                    src="img/undraw_profile_2.svg"
                    alt="..."
                  />
                  <div className="status-indicator"></div>
                </div>
                <div>
                  <div className="text-truncate">
                    I have the photos that you ordered last month, how would you
                    like them sent to you?
                  </div>
                  <div className="small text-gray-500">Jae Chun · 1d</div>
                </div>
              </a>
              <a className="dropdown-item d-flex align-items-center" href="#">
                <div className="dropdown-list-image mr-3">
                  <img
                    className="rounded-circle"
                    src="img/undraw_profile_3.svg"
                    alt="..."
                  />
                  <div className="status-indicator bg-warning"></div>
                </div>
                <div>
                  <div className="text-truncate">
                    Last month's report looks great, I am very happy with the
                    progress so far, keep up the good work!
                  </div>
                  <div className="small text-gray-500">Morgan Alvarez · 2d</div>
                </div>
              </a>
              <a className="dropdown-item d-flex align-items-center" href="#">
                <div className="dropdown-list-image mr-3">
                  <img
                    className="rounded-circle"
                    src="https://source.unsplash.com/Mv9hjnEUHR4/60x60"
                    alt="..."
                  />
                  <div className="status-indicator bg-success"></div>
                </div>
                <div>
                  <div className="text-truncate">
                    Am I a good boy? The reason I ask is because someone told me
                    that people say this to all dogs, even if they aren't
                    good...
                  </div>
                  <div className="small text-gray-500">
                    Chicken the Dog · 2w
                  </div>
                </div>
              </a>
              <a
                className="dropdown-item text-center small text-gray-500"
                href="#"
              >
                Read More Messages
              </a>
            </div>
          </li>

          <div className="topbar-divider d-none d-sm-block"></div>

          {/* Nav Item - User Information */}
          <li className="nav-item dropdown no-arrow">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                {(sessionStorage.getItem("user_credential")
                  ? JSON.parse(sessionStorage.getItem("user_credential")).f_name
                  : "") +
                  " " +
                  (sessionStorage.getItem("user_credential")
                    ? JSON.parse(sessionStorage.getItem("user_credential"))
                        .l_name
                    : "")}
              </span>
              <img
                className="img-profile rounded-circle"
                src={
                  !sessionStorage.getItem("user_credential")
                    ? "img/undraw_profile.svg"
                    : JSON.parse(sessionStorage.getItem("user_credential"))
                        .prof_pic_path
                }
                title="Profile"
              />
            </a>
            {/* Dropdown - User Information */}
            <div
              className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="userDropdown"
            >
              {/*<a className="dropdown-item" href="#">
                <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                Profile
              </a>
              <a className="dropdown-item" href="#">
                <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                Settings
              </a>
              <a className="dropdown-item" href="#">
                <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                Activity Log
              </a>*/}
              <div className="dropdown-divider"></div>
              <a
                className="dropdown-item"
                href="#"
                data-toggle="modal"
                data-target="#logoutModal"
              >
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
      {/* End of Topbar */}
      <div
        class="modal fade"
        id="logoutModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Are you sure you want to Leave?
              </h5>
              <button
                class="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              Please click on "Logout" below if you are ready to leave your
              session.
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-secondary"
                type="button"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button class="btn btn-primary" onClick={() => handleLogout()}>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Topbar;
